'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addWeeks;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addWeeks.js
// module id = 473
// module chunks = 0